export default __webpack_public_path__ + "static/media/logo_watermark.61f6396d.png";